import React from 'react';
import ColorsDefault from './ColorsDefault';

const ColorsContext = React.createContext(ColorsDefault);

export default ColorsContext;